import React, { Fragment } from 'react';
const prescriber = 
    <Fragment>
        <p>
            <b>Prescriber Authorization:</b>
            &nbsp;I attest that I have obtained written permission, in the event it is required under applicable 
            federal and/or state law of my patient (or the patient's legal representative) for the 
            release of my patient's Protected Health Information ("PHI") to Acadia Pharmaceuticals Inc. 
            or its representatives or agents (collectively "Acadia") as may be necessary for the patient's 
            participation in a program designed to assist patients in determining their insurance coverage 
            for NUPLAZID that I have elected to prescribe. I direct Acadia to convey, on my behalf, any 
            prescription information delivered to Acadia for NUPLAZID by any means under applicable law to the 
            dispensing pharmacy chosen by or for the patient, to the patient's health insurance company, 
            or to other third parties as may be necessary to assist this patient with filling his/her 
            prescription for NUPLAZID, with securing any insurance coverage for NUPLAZID to which the patient 
            is entitled, or other third parties to assist with patient assistance or reduced-cost medication. 
            I understand I am to comply with the state-specific prescription requirements such as e-prescribing, 
            state-specific prescription form, fax language, etc. I agree that Acadia may contact me for 
            additional information relating to NUPLAZID, including but not limited to via email, fax and 
            telephone. I authorize Acadia to transmit the above prescription to the pharmacy.
        </p>
    </Fragment>
export default prescriber; 